import React, { useState } from 'react';
import { Form, Input, InputNumber, Button, Card, Radio, Space, Typography, Row, Col, Select, Divider, Tag } from 'antd';
import { RightOutlined, CarOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;
const { Text } = Typography;

const Step5Carregadores = ({ onNext, onBack, formData }) => {
    const [form] = Form.useForm();
    const [hasChargers, setHasChargers] = useState(formData?.hasChargers ?? false);
    const [chargers, setChargers] = useState(formData?.carregadores || []);

    React.useEffect(() => {
        if (formData) {
            form.setFieldsValue(formData);
            if (formData.hasChargers !== undefined) setHasChargers(formData.hasChargers);
            if (formData.carregadores) setChargers(formData.carregadores);
        }
    }, [formData, form]);

    const handleAddCharger = () => {
        setChargers([...chargers, { id: Date.now(), serial: '', potencia: 22 }]);
    };

    const handleRemoveCharger = (id) => {
        setChargers(chargers.filter(c => c.id !== id));
    };

    const handleChargerChange = (id, field, value) => {
        setChargers(chargers.map(c => 
            c.id === id ? { ...c, [field]: value } : c
        ));
    };

    const handleSubmit = async (values) => {
        const data = {
            ...values,
            hasChargers,
            carregadores: hasChargers ? chargers : [],
        };
        onNext(data);
    };

    return (
        <Card title={
            <span>
                <CarOutlined style={{ marginRight: '8px', color: '#52c41a' }} />
                Estações de Recarga (Carregadores EV)
            </span>
        }>
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={formData}
            >
                <Form.Item label="Este site possui carregadores de veículos elétricos?">
                    <Radio.Group 
                        value={hasChargers} 
                        onChange={(e) => setHasChargers(e.target.value)}
                        buttonStyle="solid"
                    >
                        <Radio.Button value={true}>Sim, possui carregadores</Radio.Button>
                        <Radio.Button value={false}>Não possui carregadores</Radio.Button>
                    </Radio.Group>
                </Form.Item>

                {hasChargers && (
                    <div style={{ padding: '20px', backgroundColor: '#f6ffed', borderRadius: '8px' }}>
                        <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text strong style={{ fontSize: '16px' }}>
                                Carregadores Cadastrados ({chargers.length})
                            </Text>
                            <Button 
                                type="dashed" 
                                icon={<PlusOutlined />}
                                onClick={handleAddCharger}
                                style={{ borderColor: '#52c41a', color: '#52c41a' }}
                            >
                                Adicionar Carregador
                            </Button>
                        </div>

                        {chargers.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: '40px', backgroundColor: '#fff', borderRadius: '4px', border: '1px dashed #d9d9d9' }}>
                                <Text type="secondary">
                                    Nenhum carregador adicionado. Clique em "Adicionar Carregador" para começar.
                                </Text>
                            </div>
                        ) : (
                            <Space direction="vertical" style={{ width: '100%' }} size="middle">
                                {chargers.map((charger, index) => (
                                    <Card 
                                        key={charger.id}
                                        size="small"
                                        title={
                                            <Space>
                                                <CarOutlined />
                                                <Text strong>Carregador {index + 1}</Text>
                                            </Space>
                                        }
                                        extra={
                                            <Button 
                                                type="text" 
                                                danger 
                                                icon={<DeleteOutlined />}
                                                onClick={() => handleRemoveCharger(charger.id)}
                                                size="small"
                                            >
                                                Remover
                                            </Button>
                                        }
                                        style={{ backgroundColor: '#fff' }}
                                    >
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>
                                                    Número de Série *
                                                </Text>
                                                <Input
                                                    value={charger.serial}
                                                    onChange={(e) => handleChargerChange(charger.id, 'serial', e.target.value)}
                                                    placeholder="Ex: EV-2024-001"
                                                    required
                                                />
                                            </Col>
                                            <Col span={12}>
                                                <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginBottom: '4px' }}>
                                                    Potência Nominal *
                                                </Text>
                                                <Select
                                                    value={charger.potencia}
                                                    onChange={(value) => handleChargerChange(charger.id, 'potencia', value)}
                                                    style={{ width: '100%' }}
                                                >
                                                    <Option value={7}>
                                                        <Tag color="blue">7 kW</Tag> Padrão (Residencial)
                                                    </Option>
                                                    <Option value={11}>
                                                        <Tag color="orange">11 kW</Tag> Rápido (Comercial)
                                                    </Option>
                                                    <Option value={22}>
                                                        <Tag color="red">22 kW</Tag> Ultra-Rápido (Industrial)
                                                    </Option>
                                                </Select>
                                            </Col>
                                        </Row>
                                    </Card>
                                ))}
                            </Space>
                        )}
                    </div>
                )}

                <Form.Item style={{ marginBottom: 0, marginTop: '24px', textAlign: 'right' }}>
                    <Space>
                        <Button onClick={onBack}>
                            Voltar
                        </Button>
                        <Button 
                            type="primary" 
                            htmlType="submit"
                            icon={<RightOutlined />}
                            size="large"
                            style={{ backgroundColor: '#FB8500', borderColor: '#FB8500' }}
                        >
                            Próximo: Revisão
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default Step5Carregadores;
